import ArtifactGroupType from "../base/ArtifactGroupType";


const LotusShoes = {
  id: '112',
  name: 'Lotus Shoes',
  groupIcon: 'WhispersOfJade',
  type: ArtifactGroupType.WHISPERS_OF_JADE,
  icon: 'LotusShoes',
  power: 10
};

export default LotusShoes;
